import {
  i
} from "./chunk.FAJKIEWS.js";

// src/components/icons/jb-video-icon/jb-video-icon.css.ts
var jb_video_icon_css_default = i`svg{fill:var(--stroke-color, rgba(20, 30, 85, var(--theme-opacity-20, 0.2)));stroke:var(--stroke-color, rgba(20, 30, 85, var(--theme-opacity-20, 0.2)))}svg circle{fill:rgba(0,0,0,0)}@media(forced-colors: active){svg{fill:CanvasText;stroke:CanvasText}}`;

export {
  jb_video_icon_css_default
};
